/* eslint-disable unicorn/no-abusive-eslint-disable */
/* eslint-disable */
import * as klaro from 'klaro';

const klaroConfig = {
  lang: 'fr',
  acceptAll: true,
  mustConsent: true,
  translations: {
    fr: {
      consentModal: {
        title: 'Gestion des cookies et données personnelles',
        description: 'Ce site utilise des cookies et technologies de suivi pour analyser le trafic, personnaliser le contenu et améliorer nos services. Conformément au RGPD, vous devez donner votre consentement explicite pour l\'utilisation de ces technologies. Vous pouvez modifier vos préférences à tout moment.',
        acceptAll: 'Accepter tous les cookies',
        acceptSelected: 'Accepter la sélection',
        declineAll: 'Refuser tous les cookies',
        close: 'Fermer',
      },
      consentNotice: {
        description: 'Ce site utilise des cookies et technologies de suivi pour analyser le trafic, personnaliser le contenu et améliorer nos services. Conformément au RGPD, vous devez donner votre consentement explicite pour l\'utilisation de ces technologies. Vous pouvez modifier vos préférences à tout moment.',
      },
      purposes: {
        analytics: 'Cookies analytiques et de mesure d\'audience',
        marketing: 'Cookies publicitaires et de ciblage',
        security: 'Cookies de sécurité et de prévention des fraudes',
      },
      googleAnalytics: {
        title: 'Google Analytics',
        description: 'Google Analytics collecte des données anonymisées sur l\'utilisation du site web pour analyser le trafic, mesurer les performances et comprendre le comportement des visiteurs. Ces données nous aident à améliorer notre site et nos services.',
      },
      ok: 'Accepter',
      poweredBy: ' ',
    },
  },
  services: [
    {
      name: 'google-analytics',
      title: 'Google Analytics',
      purposes: ['analytics'],
      cookies: ['_ga', '_gid', '_gat'],
      callback: function (consent: boolean) {
        if (consent) {
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-JK26HQHQ7R');
        }
      }
    }
  ],
  privacyPolicy: '/politique-de-confidentialite/',
};

klaro.render(klaroConfig);
